
export namespace TIME {
    export const ONE_MINUTE = (1000 * 60);
    export const TEN_SEC = (1000 * 10);
    export const FIVE_SEC = (1000 * 5);
    export const SEVEN_DAYS = (1000 * 604800);
}

